var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{
    name: _vm.documentType + '-diff',
    params: { id: _vm.id, versionFrom: _vm.versionFrom || 'prev', versionTo: _vm.versionTo || 'next', lang: _vm.lang },
  },"rel":"nofollow"}},[_vm._t("default",function(){return [_vm._v("diff")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }